import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { CellContext } from '@tanstack/react-table';

export interface ChannelListChargePointNameCellProps
  extends CellContext<
    GatewayChannelWithChargePointInfoModel,
    GatewayChannelWithChargePointInfoModel['chargePointName']
  > {}

export const ChannelListChargePointNameCell = (
  props: ChannelListChargePointNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()}</Text>;
};
